var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-btn',{staticClass:"ml-1",attrs:{"role":"download-all","color":"primary","outlined":"","disabled":!_vm.isDownloadable()},on:{"click":_vm.download}},[_c('v-icon',{attrs:{"color":"primary"}},[_vm._v("mdi-file-download")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }